import axios from 'axios';

const apiClient = axios.create({
  baseURL: 'https://api.socialspectrum.org/api/v1/'
});

// Set default Content-Type
apiClient.defaults.headers.common['Content-Type'] = 'application/json';

export default apiClient;